export const BOOLEAN_VALUES = {
  TRUE: "true",
  FALSE: "false"
};
